module.exports = __webpack_public_path__ + "img/beng.790d15f7.png";